module.exports = __webpack_public_path__ + "img/kongZhiMianBan.6d771c02.svg";